import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const AbbreviationPage = () => {
  useEffect(() => {
    document.title = 'Abbreviations | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/rules">
          <div id="stick_right"></div>
        </Link>

        <div id="basic">
          <h3 className="heading3">Baseball Abbreviations</h3>

          {/* Abbreviations Container */}
          <div className="row" style={{marginTop: '20px'}}>
            <div className="col-md-4">
              <div className="panel panel-primary">
                <div className="panel-heading">
                  <h4><span className="glyphicon glyphicon-pencil"></span> HITTING STATS</h4>
                </div>
                <div className="panel-body">
                  <ul className="list-unstyled">
                    <li><strong>2B</strong> - Doubles</li>
                    <li><strong>3B</strong> - Triples</li>
                    <li><strong>AB</strong> - At Bats</li>
                    <li><strong>AB/GIDP</strong> - At-Bats per Grounded Into Double Play</li>
                    <li><strong>AB/HR</strong> - At-Bats per Home Run</li>
                    <li><strong>AB/RBI</strong> - At-Bats per Runs Batted In</li>
                    <li><strong>AO</strong> - Fly Outs</li>
                    <li><strong>AVG</strong> - Batting Average</li>
                    <li><strong>BB</strong> - Bases on Balls (Walks)</li>
                    <li><strong>CS</strong> - Caught Stealing</li>
                    <li><strong>G</strong> - Games Played</li>
                    <li><strong>GIDP</strong> - Ground into Double Plays</li>
                    <li><strong>GO</strong> - Ground Outs</li>
                    <li><strong>GO/AO</strong> - Ground Outs/Fly Outs</li>
                    <li><strong>GSH</strong> - Grand Slam Home Runs</li>
                    <li><strong>H</strong> - Hits</li>
                    <li><strong>HBP</strong> - Hit by Pitch</li>
                    <li><strong>HR</strong> - Home Runs</li>
                    <li><strong>IBB</strong> - Intentional Walks</li>
                    <li><strong>LIPS</strong> - Late Inning Pressure Situations</li>
                    <li><strong>LOB</strong> - Left On Base</li>
                    <li><strong>NP</strong> - Number of Pitches</li>
                    <li><strong>OBP</strong> - On-base Percentage</li>
                    <li><strong>OPS</strong> - On-base Plus Slugging Percentage</li>
                    <li><strong>PA/SO</strong> - Plate Appearances per Strikeout</li>
                    <li><strong>R</strong> - Runs Scored</li>
                    <li><strong>RBI</strong> - Runs Batted In</li>
                    <li><strong>SAC</strong> - Sacrifice Bunts</li>
                    <li><strong>SB%</strong> - Stolen Base Percentage</li>
                    <li><strong>SB</strong> - Stolen Bases</li>
                    <li><strong>SF</strong> - Sacrifice Flies</li>
                    <li><strong>SLG</strong> - Slugging Percentage</li>
                    <li><strong>SO</strong> - Strikeouts</li>
                    <li><strong>TB</strong> - Total Bases</li>
                    <li><strong>TP</strong> - Triple Play</li>
                    <li><strong>TPA</strong> - Total Plate Appearances</li>
                    <li><strong>XBH</strong> - Extra Base Hits</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="panel panel-primary">
                <div className="panel-heading">
                  <h4><span className="glyphicon glyphicon-pencil"></span> FIELDING</h4>
                </div>
                <div className="panel-body">
                  <ul className="list-unstyled">
                    <li><strong>A</strong> - Assists</li>
                    <li><strong>CS</strong> - Caught Stealing</li>
                    <li><strong>DP</strong> - Double Plays</li>
                    <li><strong>E</strong> - Errors</li>
                    <li><strong>FPCT</strong> - Fielding Percentage</li>
                    <li><strong>G</strong> - Games Played</li>
                    <li><strong>INN</strong> - Innings Played</li>
                    <li><strong>OFA</strong> - Outfield Assists</li>
                    <li><strong>PB</strong> - Passed Balls</li>
                    <li><strong>PO</strong> - Putouts</li>
                    <li><strong>SB</strong> - Stolen Bases (allowed)</li>
                    <li><strong>TC</strong> - Total Chances</li>
                    <li><strong>TP</strong> - Triple Plays</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="panel panel-primary">
                <div className="panel-heading">
                  <h4><span className="glyphicon glyphicon-pencil"></span> PITCHING</h4>
                </div>
                <div className="panel-body">
                  <ul className="list-unstyled">
                    <li><strong>AO</strong> - Fly Outs</li>
                    <li><strong>APP</strong> - Appearances</li>
                    <li><strong>AVG</strong> - Opponents Batting Average</li>
                    <li><strong>BB</strong> - Bases on Balls (Walks)</li>
                    <li><strong>BB/9</strong> - Walks per Nine Innings</li>
                    <li><strong>BK</strong> - Balks</li>
                    <li><strong>CG</strong> - Complete Games</li>
                    <li><strong>CGL</strong> - Complete Game Losses</li>
                    <li><strong>CS</strong> - Caught Stealing</li>
                    <li><strong>ER</strong> - Earned Runs</li>
                    <li><strong>ERA</strong> - Earned Run Average</li>
                    <li><strong>G</strong> - Games Played</li>
                    <li><strong>GF</strong> - Games Finished</li>
                    <li><strong>GIDP</strong> - Grounded Into Double Plays</li>
                    <li><strong>GO</strong> - Ground Outs</li>
                    <li><strong>GO/AO</strong> - Ground Outs/ Fly Outs Ratio</li>
                    <li><strong>GS</strong> - Games Started</li>
                    <li><strong>GSH</strong> - Grand Slams</li>
                    <li><strong>H</strong> - Hits</li>
                    <li><strong>H/9</strong> - Hits per Nine Innings</li>
                    <li><strong>HB</strong> - Hit Batsmen</li>
                    <li><strong>HLD</strong> - Hold</li>
                    <li><strong>HR</strong> - Home Runs</li>
                    <li><strong>I/GS</strong> - Innings Per Games Started</li>
                    <li><strong>IBB</strong> - Intentional Walks</li>
                    <li><strong>IP</strong> - Innings Pitched</li>
                    <li><strong>IRA</strong> - Inherited Runs Allowed</li>
                    <li><strong>K/9</strong> - Strikeouts per Nine Innings</li>
                    <li><strong>K/BB</strong> - Strikeout/Walk Ratio</li>
                    <li><strong>L</strong> - Losses</li>
                    <li><strong>LIPS</strong> - Late Inning Pressure Situations</li>
                    <li><strong>LOB</strong> - Left on Base</li>
                    <li><strong>MB/9</strong> - Baserunners per 9 Innings</li>
                    <li><strong>NP</strong> - Number of Pitches Thrown</li>
                    <li><strong>OBA</strong> - On-base Against</li>
                    <li><strong>PA</strong> - Plate Appearances</li>
                    <li><strong>P/GS</strong> - Pitches per Start</li>
                    <li><strong>P/IP</strong> - Pitches per Innings Pitched</li>
                    <li><strong>PK</strong> - Pick-offs</li>
                    <li><strong>R</strong> - Runs</li>
                    <li><strong>RW</strong> - Relief Wins</li>
                    <li><strong>SB</strong> - Stolen Bases</li>
                    <li><strong>SHO</strong> - Shutouts</li>
                    <li><strong>SLG</strong> - Slugging Percentage Allowed</li>
                    <li><strong>SO</strong> - Strikeouts</li>
                    <li><strong>SV</strong> - Saves</li>
                    <li><strong>SVO</strong> - Save Opportunities</li>
                    <li><strong>TB</strong> - Total Bases</li>
                    <li><strong>TBF</strong> - Total Batters Faced</li>
                    <li><strong>TP</strong> - Triple Plays</li>
                    <li><strong>UER</strong> - Unearned Runs</li>
                    <li><strong>W</strong> - Wins</li>
                    <li><strong>WHIP</strong> - Walks + Hits/Innings Pitched</li>
                    <li><strong>WP</strong> - Wild Pitches</li>
                    <li><strong>WPCT</strong> - Winning Percentage</li>
                    <li><strong>XBA</strong> - Extra Base Hits Allowed</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default AbbreviationPage;